import "core-js/modules/es.array.concat";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _defineProperty from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import OpenApp from './index';
import { buildUrl } from '../url';
import env from '../env';
import login from '../login';
import { getUrlParam, setUrlParam } from '../util';
import { invoke } from '@tencent/vft-atom/lib/tenvideo'; // 避免参数冲突

var PREFIX = 'o.';
var USER_TYPE = "userType";
var LOGIN_ID = "vuserid";
var NICK_NAME = "nickname";
var HEAD_IMG_URL = 'headImgUrl';
var defaultConfig = {
  scene: '活动参与账号',
  btnText: '切换到活动账号',
  hint: '检测到您原先活动参与的账号是{{userType}}账号，是否切换至该账号？',
  needRefreshAfterLogin: true
};

var OpenAppAccountCheck = /*#__PURE__*/function () {
  function OpenAppAccountCheck() {
    _classCallCheck(this, OpenAppAccountCheck);

    this.config = {};
  }
  /**
   * config 参数列表: {vuserid，userType， nickname，headImgUrl, scene, btnText, hint   }
   * @param config
   * @returns {Promise.<void>}
   */


  _createClass(OpenAppAccountCheck, [{
    key: "check",
    value: function () {
      var _check = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var config,
            _ref,
            vuserid,
            userInfo,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _ref = config || {}, vuserid = _ref.vuserid; // 没有传递vuid，组件取一次

                if (!(!vuserid && !env.isApp)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return login.getMainUserInfo();

              case 5:
                userInfo = _context.sent;

                if (userInfo) {
                  config[LOGIN_ID] = login.getVuid();
                  config[USER_TYPE] = userInfo.type;
                  config[NICK_NAME] = userInfo.nick;
                  config[HEAD_IMG_URL] = userInfo.headurl;
                }

              case 7:
                this.config = Object.assign(defaultConfig, config);
                this.accountCheck();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function check() {
        return _check.apply(this, arguments);
      }

      return check;
    }()
    /***
     * 拉起APP后，检查
     */

  }, {
    key: "accountCheck",
    value: function () {
      var _accountCheck = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var vuserid, userType, nickname, headImgUrl, _this$config, scene, btnText, hint, needRefreshAfterLogin, params, url;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (env.isApp) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                vuserid = decodeURIComponent(getUrlParam("".concat(PREFIX).concat(LOGIN_ID)));
                userType = decodeURIComponent(getUrlParam("".concat(PREFIX).concat(USER_TYPE)));
                nickname = decodeURIComponent(getUrlParam("".concat(PREFIX).concat(NICK_NAME)));
                headImgUrl = decodeURIComponent(getUrlParam("".concat(PREFIX).concat(HEAD_IMG_URL)));
                _this$config = this.config, scene = _this$config.scene, btnText = _this$config.btnText, hint = _this$config.hint, needRefreshAfterLogin = _this$config.needRefreshAfterLogin;

                if (!vuserid) {
                  _context2.next = 15;
                  break;
                }

                params = Object.assign({
                  needRefreshAfterLogin: needRefreshAfterLogin,
                  scene: scene,
                  btnText: btnText,
                  hint: (hint || '').replace(/\{\{userType\}\}/g, userType === 'wx' ? '微信' : 'QQ')
                }, {
                  vuserid: vuserid,
                  userType: userType,
                  nickname: nickname,
                  headImgUrl: headImgUrl
                }); // 避免重复提示

                url = setUrlParam("".concat(PREFIX).concat(LOGIN_ID), '', location.href);
                url = setUrlParam("".concat(PREFIX).concat(HEAD_IMG_URL), '', url);
                url = setUrlParam("".concat(PREFIX).concat(NICK_NAME), '', url); // url = setUrlParam(`${PREFIX}${USER_TYPE}`, '', url)

                window.history.replaceState({}, '', url);
                _context2.next = 15;
                return invoke('checkLoginStateByUserId', params);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function accountCheck() {
        return _accountCheck.apply(this, arguments);
      }

      return accountCheck;
    }()
  }, {
    key: "getParams",
    value: function getParams(isPageUrl) {
      var _params;

      // h5 url 后面加一个前缀，避免参数冲突
      var prefix = isPageUrl ? PREFIX : '';
      var params = (_params = {}, _defineProperty(_params, "".concat(prefix).concat(USER_TYPE), this.config[USER_TYPE]), _defineProperty(_params, "".concat(prefix).concat(LOGIN_ID), this.config[LOGIN_ID]), _defineProperty(_params, "".concat(prefix).concat(NICK_NAME), this.config[NICK_NAME]), _defineProperty(_params, "".concat(prefix).concat(HEAD_IMG_URL), this.config[HEAD_IMG_URL]), _params);

      if (!isPageUrl) {
        var _this$config2 = this.config,
            scene = _this$config2.scene,
            btnText = _this$config2.btnText,
            hint = _this$config2.hint,
            userType = _this$config2.userType;
        params.needAuthorize = 1; // app侧拉起的协议把vuserid处理成了userid，帮app补锅

        Object.assign(params, {
          userid: this.config[LOGIN_ID],
          scene: scene,
          btnText: btnText,
          hint: (hint || '').replace(/\{\{userType\}\}/g, userType === 'wx' ? '微信' : 'QQ')
        });
      }

      return params;
    }
  }, {
    key: "openApp",
    value: function () {
      var _openApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(schemaUrl) {
        var checkAccount,
            isPageUrl,
            ptag,
            from,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                checkAccount = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
                isPageUrl = /^(http|https|file)/.test(schemaUrl);

                if (checkAccount) {
                  schemaUrl = buildUrl(schemaUrl, this.getParams(isPageUrl), true);
                }

                schemaUrl = isPageUrl ? 'txvideo://v.qq.com/Html5Activity?url=' + encodeURIComponent(schemaUrl) : schemaUrl;
                ptag = getUrlParam('ptag');
                from = getUrlParam('from', schemaUrl);

                if (ptag && !from) {
                  schemaUrl = setUrlParam('form', ptag, schemaUrl);
                } // 微信手Q腾讯视频APP腾讯新闻天天快报APP内canGetInstallState为true，其他情况下canGetInstallState为false，走的是browser拉起APP的方式。


                if (!OpenApp.canGetInstallState) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 10;
                return OpenApp.getInstallState();

              case 10:
                if (!_context3.sent) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 13;
                return OpenApp.launch(schemaUrl);

              case 13:
                _context3.next = 16;
                break;

              case 15:
                // 没有安装则跳转到应用宝下载地址或直接下载(腾讯新闻天天快报内)
                OpenApp.download();

              case 16:
                _context3.next = 24;
                break;

              case 18:
                _context3.next = 20;
                return OpenApp.launch(schemaUrl);

              case 20:
                if (!_context3.sent) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 24;
                break;

              case 23:
                // 无安装
                OpenApp.download();

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function openApp(_x) {
        return _openApp.apply(this, arguments);
      }

      return openApp;
    }()
  }]);

  return OpenAppAccountCheck;
}();
/***
 * 使用方法(两步)：
 * import accountCheck from '@tencent/vft-common/openapp/openapp-account-check'
 * 1.在login.init 之后执行（重要）
 *   accountCheck.check() 支持自定义参数： scene, btnText, hint, vuserid （一般用默认的即可）
 * 2.拉起app方法使用
 *   accountCheck.openApp(url, true)
 */


export default new OpenAppAccountCheck();